import { render, staticRenderFns } from "./MatchEntry.vue?vue&type=template&id=06bf82e6&scoped=true&"
import script from "./MatchEntry.vue?vue&type=script&lang=js&"
export * from "./MatchEntry.vue?vue&type=script&lang=js&"
import style0 from "./MatchEntry.vue?vue&type=style&index=0&id=06bf82e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf82e6",
  null
  
)

export default component.exports